import { render } from "./GastosPage.vue?vue&type=template&id=0685ad0f&scoped=true"
import script from "./GastosPage.vue?vue&type=script&lang=js"
export * from "./GastosPage.vue?vue&type=script&lang=js"

import "./GastosPage.vue?vue&type=style&index=0&id=0685ad0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0685ad0f"]])

export default __exports__